var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"paypal-container"},[_c('div',{ref:"paypalButton"})])
}
var staticRenderFns = []

export { render, staticRenderFns }